import React from 'react';
import { Home, LogOut, RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';

const AdminHeader = ({ onRefresh, onLogout, refreshing }) => (
  <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
    <div className="container mx-auto px-6 h-16 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-lg bg-emerald-600 flex items-center justify-center">
          <Home className="w-5 h-5 text-white" />
        </div>
        <div>
          <div className="font-bold text-slate-900">DreamHousesUSA</div>
          <div className="text-xs text-slate-500">Admin Dashboard</div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button data-testid="admin-refresh" variant="outline" size="sm" onClick={onRefresh} disabled={refreshing}>
          <RefreshCw className={`w-4 h-4 mr-1 ${refreshing ? 'animate-spin' : ''}`} />
          Refresh
        </Button>
        <Button data-testid="admin-logout" variant="ghost" size="sm" onClick={onLogout}>
          <LogOut className="w-4 h-4 mr-1" /> Logout
        </Button>
      </div>
    </div>
  </header>
);

export default AdminHeader;
